<template>

  <v-data-table
    :headers="headers"
    :items="_items"
    :server-items-length="_total"
    :footer-props="footer"
    :no-data-text="labels.nodata"
    :options.sync="options"
    :loading="loading"
    @click:row="$emit('click', $event)"
  >
    <template v-slot:item.type="{ item }">
      <responsive-icon v-if="!item.issue.closed && item.issue.failure" :label="$t('failure')" breakpoints="xs">
        <font-awesome-icon  icon="exclamation-circle" size="lg" class="type-failure"></font-awesome-icon>
      </responsive-icon>

      <responsive-icon v-if="!item.issue.closed && item.issue.maintenance" :label="$t('maintenance')" breakpoints="xs">
        <font-awesome-icon icon="tasks" size="lg" class="type-maintenance"></font-awesome-icon>
      </responsive-icon>

      <responsive-icon v-if="item.issue.closed" :label="$t('closed')" breakpoints="xs">
        <font-awesome-icon icon="check-circle" size="lg" class="type-closed"></font-awesome-icon>
      </responsive-icon>
    </template>

    <template v-slot:item.actionAt="{ item }">
      {{ item.issue.actionAt | datetime }}
    </template>

    <template v-slot:item.workEndAt="{ item }">
      <span v-if="item.workEndAt">{{ item.workEndAt | datetime }}</span>
      <span v-if="!item.workEndAt">{{ $t('interventions.in-progress') }}</span>
    </template>

    <template v-slot:item.assets="{ item }">
      {{ item.asset.fullPath }}
    </template>

    <template v-slot:item.issues="{ item }">
      {{ item.issue.xDisplayName }}
    </template>

    <template v-slot:item.description="{ item }">
      {{ item.description }}
    </template>

  </v-data-table>

</template>

<script>

  import dataTable from '../../helpers/data-table.es6'
  import ResponsiveIcon from "../../shared/components/responsive-icon";

  export default {
    name: 'interventions-table',
    mixins: [ dataTable ],

    data () {
      return {
        sortRules: {
          assets: 'assets.name',
          issues: 'issues.name',
          actionAt: 'issues.actionAt'
        },
        headers: [
          { text: this.$t('type'), value: 'type', sortable: false },
          { text: this.$t('issues.action'), value: 'actionAt' },
          { text: this.$t('issues.solved'), value: 'workEndAt' },
          { text: this.$t('entityNames.assets'), value: 'assets' },
          { text: this.$t('entityNames.issues'), value: 'issues' },
          { text: this.$t('solution'), value: 'description' }
        ]
      }
    },

    components: {
      ResponsiveIcon
    },
  }

</script>

<style scoped lang="scss">

  @import '../../../assets/variables';

  ::v-deep {
    tbody tr td {
      cursor: pointer;
    }
  }

  .type {
    &-failure {
      color: $color-warn;
    }

    &-maintenance {
      color: $color-primary;
    }

    &-closed {
      color: $color-success;
    }
  }

  .label {
    margin-left: 5px;
  }

</style>
